import {
  ActionList,
  ActionListItem,
  ActionListItemBadge,
  Box,
  Button,
  ChevronDownIcon,
  Dropdown,
  DropdownButton,
  DropdownOverlay,
  RefreshIcon,
} from '@razorpay/blade/components';
import React from 'react';
import { StructureCreateType } from '../creation';

interface ToolbarProps {
  onRefresh: () => void;
  onCreateNew: (createType: StructureCreateType) => void;
}

const SalaryStructuresListToolbar: React.FC<ToolbarProps> = ({ onRefresh, onCreateNew }) => {
  // No longer need to return TableToolbar - just the content directly
  return (
    <Box display="flex" alignItems="center" gap="spacing.3">
      <Dropdown _width="160px">
        <DropdownButton
          isFullWidth
          testID="add-structure-button"
          iconPosition="right"
          icon={ChevronDownIcon}>
          Add Structure
        </DropdownButton>
        <DropdownOverlay>
          <ActionList>
            <ActionListItem onClick={() => onCreateNew('new')} title="Create new" value="create" />
            <ActionListItem
              onClick={() => onCreateNew('from-existing')}
              title="Create from existing structure"
              value="create-from-existing"
            />
            <ActionListItem
              onClick={() => onCreateNew('import')}
              title="Upload payslip to create template"
              value="import"
              titleSuffix={<ActionListItemBadge color="information">Exclusive</ActionListItemBadge>}
            />
          </ActionList>
        </DropdownOverlay>
      </Dropdown>
      <Button icon={RefreshIcon} variant="tertiary" onClick={onRefresh} />
    </Box>
  );
};

export default SalaryStructuresListToolbar;
